export default __webpack_public_path__ + "static/media/CADScreen@2x.e1addb93.png";